<script setup lang="ts">
/**
 * Partage d'une boutique — textes propres à la boutique ; la fenêtre est la
 * même que celle de la cagnotte (PublicShareSheet, Karim 2026-09-25).
 *
 * Levier de vente clé : une boutique associative se diffuse par WhatsApp et
 * les réseaux, pas par référencement.
 */
import type { Shop } from "~/types/shop";

const { t } = useI18n();

const props = defineProps<{
  open: boolean;
  shop: Shop | null;
}>();

const emit = defineEmits<{
  "update:open": [value: boolean];
}>();

const url = computed(() => (props.shop ? `https://donoor.org/boutique/${props.shop.slug}` : ""));
const nom = computed(() => props.shop?.title ?? "");
/** « la boutique X de l'association Y » — accroche commune à tous les canaux. */
const message = computed(() => {
  const org = props.shop?.organization_name;
  return org ? t("boutique.shareModal.messageAvecAssociation", { nom: nom.value, association: org }) : t("boutique.shareModal.messageSansAssociation", { nom: nom.value });
});
</script>

<template>
  <PublicShareSheet
    :open="open"
    :title="$t('boutique.commun.partagerLaBoutique')"
    :item-name="nom"
    :url="url"
    :message="message"
    :email-subject="$t('boutique.shareModal.sujetEmail', { nom })"
    :email-body="$t('boutique.shareModal.corpsEmail', { message, url })"
    :qr-caption="$t('boutique.shareModal.qrLegende')"
    :poster-subtitle="$t('boutique.shareModal.posterSousTitre')"
    :poster-cta="$t('boutique.shareModal.posterCta')"
    :file-name="`qrcode-${shop?.slug || 'boutique'}`"
    @update:open="(v) => emit('update:open', v)"
  />
</template>
